import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import authService, { crearCodigoIngreso } from "../services/authService";
import { useAuth } from "../context/AuthContext";
import "../styles/login.css";

const PrimerAcceso = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();

  const email = location.state?.email;
  const [codigoIngreso, setCodigoIngreso] = useState("");
  const [confirmarCodigo, setConfirmarCodigo] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email) {
      navigate("/");
    }
  }, [email, navigate]);

  const validarCodigo = (codigo) => {
    if (codigo.length < 8) return "El código debe tener al menos 8 caracteres";
    if (!/[A-Z]/.test(codigo)) return "Debe contener al menos una letra mayúscula";
    if (!/[a-z]/.test(codigo)) return "Debe contener al menos una letra minúscula";
    if (!/[0-9]/.test(codigo)) return "Debe contener al menos un número";
    if (!/[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/.test(codigo)) {
      return "Debe contener al menos un símbolo";
    }
    return "";
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    if (codigoIngreso !== confirmarCodigo) {
      setError("Los códigos no coinciden");
      setLoading(false);
      return;
    }

    const errorValidacion = validarCodigo(codigoIngreso);
    if (errorValidacion) {
      setError(errorValidacion);
      setLoading(false);
      return;
    }

    try {
      const response = await crearCodigoIngreso(email, codigoIngreso);
      const data = response.data || {};
      const access = data.access || data.tokens?.access;
      const refresh = data.refresh || data.tokens?.refresh;

      authService.persistSession({
        tokens: { access, refresh },
        user: data.user,
      });
      setSession(data.user);
      navigate("/dashboard");
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        setError(err?.response?.data?.error);
        return;
      }
      if (status === 400) {
        setError(err?.response?.data?.error || "Error inesperado. Intenta de nuevo.");
      } else if (status === 404) {
        setError("No se encontró una cuenta con ese correo");
      } else {
        setError("Error inesperado. Intenta de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="login-container">
      <Box className="login-card">
        <Typography variant="h5" className="login-title">
          Primer Acceso
        </Typography>

        <form className="login-form" onSubmit={handleSubmit}>
          <TextField
            label="Correo electrónico"
            type="email"
            fullWidth
            margin="normal"
            value={email || ""}
            disabled
          />

          <TextField
            label="Crear Código de Ingreso"
            type="password"
            fullWidth
            margin="normal"
            required
            value={codigoIngreso}
            onChange={(event) => setCodigoIngreso(event.target.value)}
            disabled={loading}
          />

          <TextField
            label="Confirmar Código de Ingreso"
            type="password"
            fullWidth
            margin="normal"
            required
            value={confirmarCodigo}
            onChange={(event) => setConfirmarCodigo(event.target.value)}
            disabled={loading}
          />

          {error && <Alert severity="error" className="login-alert">{error}</Alert>}

          <Button
            type="submit"
            variant="contained"
            color="secondary"
            fullWidth
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress
                  size={20}
                  color="inherit"
                  className="login-spinner"
                />
                Guardando...
              </>
            ) : (
              "Guardar e ingresar"
            )}
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default PrimerAcceso;
